import { Pipe, PipeTransform } from '@angular/core';

import { NgSelectModel } from '../../shared/models/ng-select.model';

@Pipe({
    name: 'mapToNgSelect',
    standalone: false
})
export class MapToNgSelectPipe implements PipeTransform {

  transform(value: string): NgSelectModel {
    return {
      value,
      disabled: false
    };
  }

}
